export const OPEN_AI_CHAT = "OPEN_AI_CHAT";
export const CLOSE_AI_CHAT = "CLOSE_AI_CHAT";
export const TOGGLE_AI_CHAT = "TOGGLE_AI_CHAT";
export const OPEN_AI_CHAT_WITH_CONTEXT = "OPEN_AI_CHAT_WITH_CONTEXT";
export const CLEAR_AI_CHAT_CONTEXT = "CLEAR_AI_CHAT_CONTEXT";
export const SET_AI_CHAT_PREDEFINED_PROMPT = "SET_AI_CHAT_PREDEFINED_PROMPT";
export const CLEAR_AI_CHAT_PREDEFINED_PROMPT =
  "CLEAR_AI_CHAT_PREDEFINED_PROMPT";
export const OPEN_AI_CHAT_WITH_HELP_CENTER_URL =
  "OPEN_AI_CHAT_WITH_HELP_CENTER_URL";
export const CLEAR_AI_CHAT_HELP_CENTER_URL = "CLEAR_AI_CHAT_HELP_CENTER_URL";

export type WsMemberSelectedContext =
  | {
      type: "selectedWsTasks";
      data: Array<{ uuid: string; title: string }>;
    }
  | {
      type: "socialUsername";
      data: Array<{ title: string }>;
    }
  | {
      type: "selectedWsGlobalTasks";
      data: Array<{ uuid: string; title: string }>;
    }
  | {
      type: "selectedSocialInsightsDashboards";
      data: Array<{ uuid: string; title: string }>;
    };

export type AIChatActionTypes =
  | { type: typeof OPEN_AI_CHAT }
  | { type: typeof CLOSE_AI_CHAT }
  | { type: typeof TOGGLE_AI_CHAT }
  | {
      type: typeof OPEN_AI_CHAT_WITH_CONTEXT;
      payload: { wsMemberSelectedContext: WsMemberSelectedContext };
    }
  | { type: typeof CLEAR_AI_CHAT_CONTEXT }
  | {
      type: typeof SET_AI_CHAT_PREDEFINED_PROMPT;
      payload: { chatInput: string; predefinedPrompt: string };
    }
  | { type: typeof CLEAR_AI_CHAT_PREDEFINED_PROMPT }
  | {
      type: typeof OPEN_AI_CHAT_WITH_HELP_CENTER_URL;
      payload: { helpCenterUrl: string };
    }
  | { type: typeof CLEAR_AI_CHAT_HELP_CENTER_URL };
